<template>
	<div class="a-footer">
		<wStackedContentBanner
      heading="About Us"
      subheading="Who we are"
      image="/images/about-assurity.png"
      alt=""
      :stackedContent="[
        {
          heading: 'Certified for good',
          content:
            '<p>As the largest insurance company to be a Certified B Corporation, we’re working to make business better for people and the planet. <a href=\'https://www.assurity.com/goodbusiness\' target=\'_blank\'>See how B Corps like Assurity are changing the world.</a></p>',
          image: '/images/bcorp.png',
          imageAlt:
            'Certified B corporation. This company meets the highest standards of social and environmental impact.',
          placeholder: { width: 200, height: 100 }
        },
        {
          heading: 'Award-winning service',
          content:
            '<p>There’s a reason Newsweek named our customer service among the best in America – you can manage your coverage online, or talk to a real person in Lincoln, Nebraska for help with whatever you need.</p>',
          image: '/images/newsweek2021.png',
          imageAlt: 'Newsweek, best life insurance customer service, 2021',
          placeholder: { width: 200, height: 94 }
        }
      ]"
    />
			<a-dotted-line />
		<footer class="footer">
			<div class="disclaimer-content">
			<disclaimers />
			</div>
			<!-- <div class="disclaimer-content">
			</div> -->
			<div class="footer-content">
			<div class="copyright">&copy; 2019 - {{new Date().getFullYear()}} Assurity Group, Inc.</div>
			<div class="legal">
				<a href="https://www.assurity.com/legal-information">Privacy & Consumer Notices</a>
			</div>
			</div>
		</footer>
	</div>
</template>

<script>
import ADottedLine from '@/components/a-dotted-line'
import wStackedContentBanner from './web/wStackedContentBanner.vue'
import Disclaimers from './disclaimers.vue'
import Exclusions from '@/components/exclusions/exclusions.vue'
export default {
	components: {
		ADottedLine,
		wStackedContentBanner,
		Disclaimers
	},
	data(){
		return {
			bullets: [
				{
					title: 'Mutual Strength',
					body: 'For 129 years, our financial strength has helped people support one another through difficult times.'
				},
				{
					title: 'A force for good',
					body: 'As a Certified B Corporation, we work toward positive impacts for employees, communities, and the environment.'
				},
				{
					title: 'Personal service',
					body: 'Get the customer service you need from real, responsive, and efficient people in our Lincoln, Nebraska headquarters.'
				}
			]
		}
	}
}
</script>

<style lang="scss" scoped>
	.a-footer {
		margin: auto;
	}
	.dotted-line {
		margin: 20px 100px;
		display: flex;
		height: 2px;
	}
	.why-assurity {
		background: $navy;
		max-width: 1580px;
		padding: 70px 100px 80px 100px;
		margin: 100px 100px;
	}
	.vertical-dots {
		width: 5px;
		background-image: url('../assets/images/gray-vertical-oval.svg');
		margin-right: 20px;
		background-repeat: round;
		background-size: 10px 8px;
	}
	.why-assurity__title {
		color: $white;
		font-size: 2.5em;
		text-align: center;
		font-weight: bold;
		margin-bottom: 50px;
	}
	.why-assurity__bullet-wrapper {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-gap: 20px 50px;
}
.why-assurity__bullet {
	display: flex;
}
.why-assurity__bullet-title {
	color: $teal;
	font-family: 'Garamond', serif;
	font-style: italic;
	font-weight: 500;
	font-size: 1.6em;
	margin-bottom: 20px;
}
.why-assurity__bullet-body {
	color: $lightgray;
}
.footer {
	border-bottom: 50px solid $red;
}
.disclaimer-content {
	max-width: 1920px;
	margin: 10px 100px;
	margin-top: 50px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 20px;
	@media (max-width: 850px) {
		margin: 10px 20px;
	}
	@media (max-width: 700px) {
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	a {
		color: $red;
		text-decoration: none;
	}
}
.footer-content {
	max-width: 1920px;
	margin: 10px 100px;
	margin-bottom: 50px;
	display: flex;
	justify-content: space-between;
	padding: 20px;
	@media (max-width: 850px) {
		margin: 10px 20px;
		margin-bottom: 50px;
	}
	@media (max-width: 700px) {
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	a {
		color: $red;
		text-decoration: none;
	}
}
</style>
